import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import PublicLayout from '../../components/Common/PublicLayout';
import storage from '../../lib/storage';
import ConfirmEmail from './ConfirmEmail';
import RegistrationAside from './RegistrationAside';
import RegistrationForm from './RegistrationForm';
import RegistrationFormWithAccessToken from './RegistrationFormWithAccessToken';

const RegistrationScreen = () => {
  const { i18n } = useTranslation('registration');

  const { lang } = useParams<{ lang: string }>();
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const [email, setEmail] = useState('');
  const languages = i18n.languages;
  const browserLang = languages[0];

  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2) || browserLang!.substring(0, 2);
  const channel = query.get('channel');
  const countryCode = query.get('countryCode');
  const accessToken = query.get('accessToken');

  return (
    <PublicLayout basePath={'register'} history={history} lang={detectedLang} aside={<RegistrationAside />}>
      {email ? (
        <ConfirmEmail email={email} lang={detectedLang} />
      ) : (
        <>
          {!accessToken && (
            <RegistrationForm
              history={history}
              channel={channel || 'PPC'}
              countryCode={countryCode}
              setEmail={setEmail}
              defaultEmail={query.get('email') || ''}
            />
          )}

          {accessToken && (
            <RegistrationFormWithAccessToken
              history={history}
              lang={detectedLang}
              channel={channel || 'PPC'}
              countryCode={countryCode}
            />
          )}
        </>
      )}
    </PublicLayout>
  );
};

export default RegistrationScreen;
